// extracted by mini-css-extract-plugin
export default {"container":"Lb","header":"Mb","logodesktop":"Nb","logomobile":"Ob","imgcontainer":"Pb","slidercontainer":"Qb","slick-slider":"Rb","slick-initialized":"Sb","sliderbox":"Tb","headline":"Ub","mainheadline":"Vb","capitalize":"Wb","desc":"Xb","descitalic":"Yb","desccenter":"Zb","descborder":"ac","subdesc":"bc","welcomeslide":"cc","desccard":"ec","img":"fc","button":"gc","buttonskip":"hc","customPosition":"ic"};
    if(module.hot) {
      // 1713361647800
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  